module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AUTHOR’S NOTE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This is a work of fiction based on fact. Because my protagonists are not wholly invented, I have felt a duty to their memories, and whenever there were holes in my information about them, such as often happened with the five little-known nuns who died in the shipwreck, I have sought similarities in the memoirs of other European religious in the nineteenth century. With Hopkins himself, a great deal more background was available and the novelist’s function became that of making dramatic what is otherwise contained in Hopkins’s letters and journals. Care has been taken not to contradict biographical details or historical testimony, but the characters finally represent my own interpretation of people who actually lived more than a century ago.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfc45a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780374150976_fm01.vue
// module id = 78
// module chunks = 0